import React,{useEffect, useState,useRef} from 'react';
import HobbyStyles from './Hobby.module.css';
import {getImages} from '../../../utils.js';
import Spinner from '../../Reusables/Spinner/Spinner.js';


function HobbyImages({imagesPaths,activeImageIndex,name,activeImageRef}){
    return <div className={HobbyStyles.HobbyImageContainer}>
                {imagesPaths.map((imagePath,imagePathIndex)=>
                    imagePathIndex===activeImageIndex
                        ?<img ref={activeImageRef}
                            key={imagePathIndex}
                            alt={name} 
                            src={imagePath}
                            className={`${HobbyStyles.HobbyImage}  ${HobbyStyles.Active}`}
                        />
                        :<img
                            key={imagePathIndex}
                            alt={name} 
                            src={imagePath}
                            className={HobbyStyles.HobbyImage}
                        />
                    )}
            </div>
}
function HobbyName({name}){
    return <h2 className={HobbyStyles.HobbyName}>{name}</h2>
}


function onMouseDownEvent(clickEvent){
    clickEvent.preventDefault();
}
export default function Hobby({name,slideShowSpeed}){
    const activeImageRef=useRef(null); //DOM Ref To Active Image
    const [imagesPaths,setImagesPaths]=useState([]); //List Of All Images Paths are stored in an array
    const [activeImageIndex,setActiveImageIndex]=useState(0); //Active Image Index (From array above) 
    const [isHovering,setIsHovering]=useState(false); //Whether we are hovering over the hobby image or not
    const [onHoverEventListener]=useState(  //Event Listener that will be bound to the active image, on hover
        ()=>
            ({target:hoveredOverImageDOM})=>{
                setIsHovering(true);
            }
    )
    const [onMouseExitEventListener]=useState( //Event Listener that will be bound to the active image, on mouseexit
        ()=>
            ({target:mouseExitFromImageDOM})=>{
                setIsHovering(false);
            }
    )
    const imagesNumber=imagesPaths.length;
    useEffect(()=>{
        async function fetchHobbyImages(){
            setImagesPaths(await getImages(`/hobbies/${name}`));
        }
        fetchHobbyImages();
    },[name])
    useEffect(()=>{
        if (imagesNumber===0)
            return;
        const {current:activeImageDom}=activeImageRef;
        if (window.screen.width>480){
            activeImageDom.addEventListener('mousedown',onMouseDownEvent)
            activeImageDom.addEventListener('mouseover',onHoverEventListener);
            activeImageDom.addEventListener('mouseout',onMouseExitEventListener);
        }
        const slideShowHobbyImages=setInterval(
            ()=>{
                if (!isHovering){
                    if (window.screen.width>480){
                        activeImageDom.removeEventListener('mouseover',onHoverEventListener);
                        activeImageDom.removeEventListener('mouseout',onMouseExitEventListener);
                    }
                    setActiveImageIndex(function(previousActiveImageIndex){
                        const newActiveImageIndex=(previousActiveImageIndex+1)%imagesNumber;
                        return newActiveImageIndex;
                    });
                    }
            },slideShowSpeed
        )
        return ()=>clearInterval(slideShowHobbyImages);
    },[imagesNumber, isHovering, onHoverEventListener, onMouseExitEventListener, slideShowSpeed,activeImageIndex,activeImageRef]);
    return imagesNumber===0
            ?<Spinner/>
            :<div className={HobbyStyles.Hobby}>
                <HobbyImages imagesPaths={imagesPaths} name={name} activeImageRef={activeImageRef} activeImageIndex={activeImageIndex}/>
                <HobbyName name={name}/>
            </div>
}